var map = {
	"./about.svg": 4,
	"./aesthetische-gruende.svg": 5,
	"./agim.svg": 6,
	"./anesthesia.svg": 7,
	"./arrow.svg": 8,
	"./atemprobleme.svg": 9,
	"./auge.svg": 10,
	"./augenfalten-kraehenfuesse.svg": 11,
	"./autogene-zahntransplantation.svg": 12,
	"./bett.svg": 13,
	"./bohrung.svg": 14,
	"./calendar.svg": 15,
	"./chat.svg": 16,
	"./chirurguische-massnahmen.svg": 17,
	"./close.svg": 18,
	"./consult.svg": 19,
	"./decay.svg": 20,
	"./dental.svg": 21,
	"./dentist.svg": 22,
	"./dentist2.svg": 23,
	"./dormicumsedierungen.svg": 24,
	"./download.svg": 25,
	"./eingeschraenkte-nasenatmung.svg": 26,
	"./entfernung-tumoren-mundhoehle.svg": 27,
	"./entzuendungen-zahnhalteapparates.svg": 28,
	"./erblicheVeranlagung.svg": 29,
	"./eye.svg": 30,
	"./face.svg": 31,
	"./facelift.svg": 32,
	"./falsches-kontaktgefuehl.svg": 33,
	"./falten-hals-dekollete.svg": 34,
	"./fehlstellung.svg": 35,
	"./filling.svg": 36,
	"./fliehendes-kinn.svg": 37,
	"./funktionelle-gruende.svg": 38,
	"./gesichtschirurgie.svg": 39,
	"./gesichtsprofil.svg": 40,
	"./insuffizienter-lippenschluss.svg": 41,
	"./kauapparat.svg": 42,
	"./kinn.svg": 43,
	"./knitterfalten.svg": 44,
	"./knochenbiopsien.svg": 45,
	"./korrektur-zahnfleisch-schleimhaut.svg": 46,
	"./kreuzbiss.svg": 47,
	"./lachfalten.svg": 48,
	"./link-arrow.svg": 49,
	"./location.svg": 50,
	"./logo-small.svg": 51,
	"./logo.svg": 52,
	"./loop.svg": 53,
	"./luecke.svg": 54,
	"./mail.svg": 55,
	"./minus.svg": 56,
	"./molecule.svg": 57,
	"./mundhoehle.svg": 58,
	"./mundhygiene.svg": 59,
	"./naehen-schliessen.svg": 60,
	"./nasenfalten.svg": 61,
	"./natuerlichkeit.svg": 62,
	"./nikotinkonsum.svg": 63,
	"./ohr.svg": 64,
	"./ohrRing.svg": 65,
	"./operation.svg": 66,
	"./play-button.svg": 67,
	"./plus.svg": 68,
	"./prothese-zahnprothese.svg": 69,
	"./roentgen.svg": 70,
	"./schlaf.svg": 71,
	"./schmerzen.svg": 72,
	"./scroll-down-arrow.svg": 73,
	"./scroll-up-arrow.svg": 74,
	"./search.svg": 75,
	"./segelohren.svg": 76,
	"./smartphone.svg": 77,
	"./sonne.svg": 78,
	"./sprechstoerung.svg": 79,
	"./stirnfalten.svg": 80,
	"./stress.svg": 81,
	"./stressUhr.svg": 82,
	"./teeth.svg": 83,
	"./thin-plus.svg": 84,
	"./verletzung-ohrmuschel.svg": 85,
	"./vorbiss-unterkiefers.svg": 86,
	"./wurzelspitzen-resektion.svg": 87,
	"./zaehne.svg": 88,
	"./zahn.svg": 89,
	"./zahnentfernung.svg": 90,
	"./zahnerhaltung.svg": 91,
	"./zahnextraktionen-zahnziehen.svg": 92,
	"./zahnimplantat.svg": 93,
	"./zahnlockerung.svg": 94,
	"./zahnlos.svg": 95,
	"./zahnreinigung.svg": 96,
	"./zahnschmerzen.svg": 97,
	"./zahnuntersuchung.svg": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;